import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, IconColor, IconName, IconSize, Link, LinkTarget, LinkVariant } from '@as/cotopaxi';
import { SocialMedia } from '@as-react/common-types';
import { Box, Stack, TextAlpha } from '@yonderland/andes-react';
const iconDefaults = {
    size: IconSize.MEDIUM,
};
const alignmentDefaults = {
    justify: 'center',
    align: 'center',
};
const SocialLinks = ({ title, emphasizeTitle = false, socialMediaLinks, iconColor, alignment, iconsGutter = '0', }) => {
    const filteredLinks = socialMediaLinks && socialMediaLinks.filter(({ socialLink }) => !!socialLink);
    if (!filteredLinks || filteredLinks.length === 0)
        return null;
    const socialIcon = Object.assign(Object.assign({}, iconDefaults), { color: iconColor });
    const stackAlignment = Object.assign(Object.assign({}, alignmentDefaults), alignment);
    const getIconName = (socialMedia) => {
        switch (socialMedia) {
            case SocialMedia.FACEBOOK:
                return IconName.FACEBOOK_BOX;
            case SocialMedia.INSTAGRAM:
                return IconName.INSTAGRAM;
            case SocialMedia.TWITTER:
                return IconName.TWITTER;
            case SocialMedia.LINKEDIN:
                return IconName.LINKEDIN_BOX;
            case SocialMedia.PINTEREST:
                return IconName.PINTEREST_BOX;
            case SocialMedia.YOUTUBE:
                return IconName.YOUTUBE_BOX;
            case SocialMedia.STRAVA:
                return IconName.STRAVA;
            case SocialMedia.TIKTOK:
                return IconName.TIKTOK;
            default:
                return null;
        }
    };
    const renderSocialLink = (socialLink, index) => {
        const name = getIconName(socialLink.socialName);
        if (!name) {
            return null;
        }
        return (_jsx(Link, { href: socialLink.socialLink, target: LinkTarget.BLANK, variant: LinkVariant.SUBTLE_ALT, children: _jsx(Box, { padding: "2", children: _jsx(Icon, { name: name, size: socialIcon.size, color: socialIcon.color === IconColor.DEFAULT ? undefined : socialIcon.color }) }) }, index));
    };
    return (_jsxs(Stack, { direction: "col", justify: stackAlignment.justify, align: stackAlignment.align, gap: "3", children: [title ? (_jsx(TextAlpha, { as: "span", strong: emphasizeTitle, color: "current", children: title })) : null, _jsx(Stack, { justify: "center", gap: iconsGutter, children: filteredLinks.map((social, index) => renderSocialLink(social, index)) })] }));
};
export default SocialLinks;
